import React from 'react';

import classnames from 'classnames/bind';

import useChapterIntroductionTextHistoryModal from '@HOOKS/store/modals/useChapterIntroductionTextHistoryModal';

import BaseModal from '@MODALS/BaseModal';
import SimpleLargeModalHeader from '@COMPONENTS/SHARED/SimpleLargeModalHeader';
import BasicHistoryList from '@MODALS/History/components/BasicHistoryList';

import styles from './ChapterIntroductionTextHistoryModal.module.scss';

const cx: CX = classnames.bind(styles);

function ChapterIntroductionTextHistoryModal() {
    const {
        state: { data: modalParams },
        actions: chapterIntroductionTextHistoryModalActions,
    } = useChapterIntroductionTextHistoryModal(() => true);

    const { chapterData } = modalParams!;

    function handleClose() {
        chapterIntroductionTextHistoryModalActions.close();
    }

    return (
        <BaseModal
            style={{
                top: 30,
                height: '100%',
                width: 'calc(100% - 60px)',
            }}
            onClose={() => handleClose()}
        >
            <div className={cx('chapter-introduction-text-history-modal')}>
                <div className={cx('header-wrapper')}>
                    <SimpleLargeModalHeader
                        modalTitle="Introduction text history"
                        title=""
                        onClose={() => handleClose()}
                    />
                </div>

                <div className={cx('content')}>
                    <BasicHistoryList
                        versions={chapterData.introductionText.versions}
                        isLandscape={false}
                        paginationLimit={5}
                    />
                </div>
            </div>
        </BaseModal>
    );
}

export default ChapterIntroductionTextHistoryModal;
